const OUTER_MARKDOWN_FENCE_OPENER = "```markdown\n"
const CLOSED_OUTER_MARKDOWN_FENCE_PATTERN = /^```markdown\n([\s\S]*?)```\s*$/
const FENCE_LINE_START = "\n```"

export function stripOuterMarkdownFence(content: string): string {
  const closed = CLOSED_OUTER_MARKDOWN_FENCE_PATTERN.exec(content)
  if (closed) return closed[1]
  if (!content.startsWith(OUTER_MARKDOWN_FENCE_OPENER)) return content
  const body = content.slice(OUTER_MARKDOWN_FENCE_OPENER.length)
  return body.includes(FENCE_LINE_START) ? content : body
}
